// extracted by mini-css-extract-plugin
module.exports = {"icon":"IgnoreIntervalsPerDay_icon__NuBaS"};